import { render, staticRenderFns } from "./FCDashboardAcceptedSelector.vue?vue&type=template&id=521c2656&scoped=true&"
import script from "./FCDashboardAcceptedSelector.vue?vue&type=script&lang=js&"
export * from "./FCDashboardAcceptedSelector.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboardAcceptedSelector.vue?vue&type=style&index=0&id=521c2656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c2656",
  null
  
)

export default component.exports